import React from "react";
import "./AnimationsStyle.scss";
import { animationsTextContent } from "./constant/index";
import SectionHeading from "../Common_UI_Kit/SectionHeading";
import CustomButton from "../Common_UI_Kit/CustomButton";
import { useNavigate } from "react-router-dom";

const AnimationsSection = () => {
  const navigate = useNavigate();

  const handleButtonClick = () => {
    navigate(`/slot-games-list`);
  };

  return (
    <section className="animations-section">
      <div className="animations-wrap">
        <SectionHeading>{animationsTextContent.headingText}</SectionHeading>

        <div className="animations-box">
          <p className="para-text">{animationsTextContent.paraText}</p>

          <div className="animation-wrap">
            <img src={animationsTextContent.imageSrc} alt="Image" />
          </div>

          {/* <div className="btn-box">
            <CustomButton
              buttonType="secondary"
              label={animationsTextContent.btnText}
              onClick={handleButtonClick}
            />
          </div> */}
        </div>
      </div>
    </section>
  );
};

export default AnimationsSection;
